import type { FolderItemsViewParams } from '../../../hooks/workspace/useFolderItems';
import type { WorkspaceView } from '../../../stores/workspaceViewPrefsStore';

/** The layouts a phone offers: Folder view and the list. */
export const PHONE_VIEWS: ReadonlyArray<WorkspaceView> = ['folders', 'list'];

/** The layout a phone shows for a view value: Card view shows as the list. */
export const phoneView = (view: WorkspaceView): WorkspaceView =>
  view === 'folders' ? 'folders' : 'list';

/**
 * The phone's touch-target floor for the controls it shares with the desktop
 * header (search, Add, scope and filter chips, the layout switch), which draw
 * at 28 to 36px there. Applied by the mobile header and toolbar to every
 * button inside them; menus open in a portal, outside its reach.
 */
export const TOUCH_TARGETS = {
  '& button': { minHeight: '44px', minWidth: '44px' },
} as const;

/** What every mobile workspace view takes, the same shape as the desktop views. */
export interface MobileViewProps {
  /** null = the workspace root. */
  readonly folderId: string | null;
  readonly viewParams: FolderItemsViewParams;
  /** The view's accessible name, the open folder's name. */
  readonly ariaLabel: string;
}
